import { render, staticRenderFns } from "./manufacturer.vue?vue&type=template&id=07e39e06&scoped=true&"
import script from "./manufacturer.vue?vue&type=script&lang=js&"
export * from "./manufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e39e06",
  null
  
)

export default component.exports